import { render } from "./history.vue?vue&type=template&id=2bdaf7b8&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"

import "./history.vue?vue&type=style&index=0&id=2bdaf7b8&scoped=true&lang=css"

import exportComponent from "/studio/gordon/Studio/mylink-intgr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdaf7b8"]])

export default __exports__